export enum LanguageMode{
    Both_Languages_are_visible = 1 ,
    English_Language_only_is_visible = 2 ,
    Arabic_Language_only_is_visible = 3 ,
    Both_Languages_but_only_English_is_required = 4,
    Both_Languages_but_only_Arabic_is_required = 5,
    Current_Language_only_is_visible_and_required = 6 ,
    Both_Languages_are_visible_but_only_current_language_is_required = 7 
 }